import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const error = params.get("error");
  const { settings } = useSettings();

  const login = () => {
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-forest-dark px-4">
      <div className="w-full max-w-md rounded-2xl border border-offwhite/10 bg-forest/40 p-8 backdrop-blur-sm sm:p-10">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src={settings.logo || "/logo.jpg"} alt="Warehouse Coffee" className="h-16 w-16 rounded bg-white p-1.5" />
          <h1 className="mt-4 font-display text-xl font-extrabold tracking-tight text-offwhite">WAREHOUSE COFFEE</h1>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-offwhite/50">Admin Dashboard</p>
        </div>
        {error && (
          <div data-testid="admin-login-error" className="mb-5 rounded-lg border border-rose-500/30 bg-rose-500/10 px-4 py-3 font-body text-sm text-rose-200">{error}</div>
        )}
        <p className="mb-6 text-center font-body text-sm leading-relaxed text-offwhite/65">Sign in with your authorized Google account to manage inventory, RFQs and site content.</p>
        <button data-testid="admin-google-login" onClick={login} className="flex w-full items-center justify-center gap-3 rounded-full bg-offwhite px-6 py-4 font-display text-sm font-bold uppercase tracking-wider text-espresso-dark transition-all hover:bg-white">
          <svg className="h-5 w-5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.6 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.3-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.6 4.5 24 4.5 16.3 4.5 9.7 8.9 6.3 14.7z"/><path fill="#4CAF50" d="M24 43.5c5.5 0 10.3-1.9 13.8-5.1l-6.4-5.4c-2 1.5-4.6 2.5-7.4 2.5-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.6 39 16.2 43.5 24 43.5z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.4 5.4c-.5.4 6.8-4.9 6.8-14.9 0-1.2-.1-2.3-.3-3.5z"/></svg>
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
